import { environment } from 'environments/environment';

const EXPORT_KEY_MAP: Record<string, string> = {
  IGV_Importe: 'IVA_Importe',
  IGV_importe: 'IVA_importe',
  IGV_Importe_Proveedor: 'IVA_Importe_Proveedor',
  IGVProv: 'IVA_Prov',
  IGVAdq: 'IVA_Adq',
  IGV_porcentaje: 'IVA_porcentaje',
  Factoring_SUNAT_importe: 'Factoring_DIAN_importe',
  Base_Importe_Soles: 'Base_Importe_COP',
  RUCProv: 'NIT_Prov',
  RUCAdq: 'NIT_Adq',
  Prov_RUC: 'Prov_NIT',
  Adq_RUC: 'Adq_NIT',
};

/** Renombra columnas Perú → Colombia al exportar Excel en modo Servifin. */
export function servifinExportRows<T extends Record<string, any>>(rows: T[]): T[] {
  if (!environment.SERVIFIN_MODE || !rows || !rows.length) {
    return rows;
  }
  return rows.map(row => {
    const out: Record<string, any> = {};
    Object.keys(row).forEach(key => {
      let newKey = EXPORT_KEY_MAP[key] || key;
      if (newKey === key) {
        newKey = key
          .replace(/IGV/g, 'IVA')
          .replace(/RUC/g, 'NIT')
          .replace(/SUNAT/g, 'DIAN')
          .replace(/Soles/g, 'COP')
          .replace(/Lima/g, 'Cali')
          .replace(/Peru/gi, 'Colombia');
      }
      out[newKey] = row[key];
    });
    return out as T;
  });
}

export function servifinExportFilename(base: string): string {
  if (!environment.SERVIFIN_MODE) {
    return base;
  }
  let name = base
    .replace(/Innova|Faktorlab|DigitalFactoring|Peru|Perú|Lima|Andean/gi, 'Servifin')
    .replace(/Servifin+/gi, 'Servifin');
  if (!/^Servifin/i.test(name)) {
    name = `Servifin_${name}`;
  }
  return name;
}

export const servifinLabels = {
  igv: environment.LABEL_IGV || 'IVA',
  ruc: environment.LABEL_RUC || 'NIT',
  docIdent: environment.LABEL_DOC_IDENT || 'NIT / C.C.',
  monedaLocal: environment.LABEL_MONEDA_LOCAL || 'Pesos COP',
  entidad: environment.LABEL_IMPUESTO_ENTIDAD || 'DIAN',
  empresa: environment.SERVIFIN_EMPRESA_NOMBRE || 'SERVIFIN S.A.S',
  tagline: environment.SERVIFIN_TAGLINE || 'Servicios Financieros',
  ciudad: environment.SERVIFIN_EMPRESA_CIUDAD || 'Cali',
  pais: environment.SERVIFIN_EMPRESA_PAIS || 'Colombia',
};

/** Filas de encabezado corporativo (empresa, ciudad, país) para exports Excel. */
export function servifinExportHeaderAoA(): any[][] {
  if (!environment.SERVIFIN_MODE) {
    return [];
  }
  const ts = new Date().toLocaleString('es-CO', { timeZone: 'America/Bogota' });
  return [
    [servifinLabels.empresa],
    [servifinLabels.tagline],
    [`${servifinLabels.ciudad}, ${servifinLabels.pais}`],
    [`Generado: ${ts}`],
    [],
  ];
}
